import {
    LeftOutlined,
    RightOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    SwapOutlined,
    UndoOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
} from "@ant-design/icons";
import { Image, Space } from "antd";
import React from "react";
import PropTypes from "prop-types";

// you can download flipped and rotated image
// https://codesandbox.io/s/zi-ding-yi-gong-ju-lan-antd-5-7-0-forked-c9jvmp
const ImagePreview = ({ imageList }) => {
    const [, setCurrent] = React.useState(0);

    // Download functionality available but currently unused
    // const onDownload = () => {
    //     const url = imageList[current];
    //     const suffix = url.slice(url.lastIndexOf("."));
    //     const filename = Date.now() + suffix;
    //     fetch(url)
    //         .then((response) => response.blob())
    //         .then((blob) => {
    //             const blobUrl = URL.createObjectURL(new Blob([blob]));
    //             const link = document.createElement("a");
    //             link.href = blobUrl;
    //             link.download = filename;
    //             document.body.appendChild(link);
    //             link.click();
    //             URL.revokeObjectURL(blobUrl);
    //             link.remove();
    //         });
    // };
    return (
        <Image.PreviewGroup
            preview={{
                toolbarRender: (
                    _,
                    {
                        transform: { scale },
                        actions: {
                            onActive,
                            onFlipY,
                            onFlipX,
                            onRotateLeft,
                            onRotateRight,
                            onZoomOut,
                            onZoomIn,
                            onReset,
                        },
                    },
                ) => (
                    <Space size={12} className="toolbar-wrapper">
                        <LeftOutlined onClick={() => onActive?.(-1)} />
                        <RightOutlined onClick={() => onActive?.(1)} />
                        {/* <DownloadOutlined onClick={onDownload} /> */}
                        <SwapOutlined rotate={90} onClick={onFlipY} />
                        <SwapOutlined onClick={onFlipX} />
                        <RotateLeftOutlined onClick={onRotateLeft} />
                        <RotateRightOutlined onClick={onRotateRight} />
                        <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
                        <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
                        <UndoOutlined onClick={onReset} />
                    </Space>
                ),
                onChange: (index) => {
                    setCurrent(index);
                },
            }}>
            {imageList.map((item, index) => (
                <div
                    key={index}
                    style={{
                        width: "84px",
                        height: "84px",
                        padding: "8px",
                        border: "1px solid #d9d9d9",
                        borderRadius: "8px",
                    }}>
                    <Image
                        key={item}
                        src={item}
                        width="100%"
                        height="100%"
                        style={{ aspectRatio: 1, objectFit: "cover" }}
                    />
                </div>
            ))}
        </Image.PreviewGroup>
    );
};

ImagePreview.propTypes = {
    imageList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ImagePreview;
